import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

import Spinner from '@/views/components/Spinner/Spinner';
import { ModalContext } from '@/utils/contexts/ModalContext';
import api from '@/services/api';

import styles from '@/views/components/Modal/ModalDelete.module.scss';

const ModalCheckTemplateAfterSimplification = () => {
	const { dict } = useSelector((state) => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);
	const navigate = useNavigate();

	const { 
		closeModal, 
		modalAdditionalInfo: { templateId },
	} = useContext(ModalContext);

	const handleUpdateNotNeeded = async () => {
		setRequestIsPending(true);
		api.put(`/letter-templates/${templateId}/final`).then(() => {
			closeModal();
			navigate(0);
			setRequestIsPending(false);
		});
	};

	const goToTemplateEditing = async () => {
		navigate(`/edit-template/${templateId}`);
		closeModal();
	};

	return (
		<div className='modal__content modal__delete-file'>
			{ requestIsPending && (
				<div className='letter__edit-metadata--spinner'>
					<Spinner />
				</div>
			) }
			<div className={ styles['delete'] }>
				<h3 className={ styles['delete--title'] }>
					{ dict.modals.checkTemplateAfterSimplification.head }
				</h3>

				<div className={ styles['delete--comment'] }>
					<p>{ dict.modals.checkTemplateAfterSimplification.text }</p>
				</div>

				<section className={ styles['delete--buttons'] }>
					<div
						className='button__std'
						onClick={ handleUpdateNotNeeded }
					>
						{ dict.modals.checkTemplateAfterSimplification.cancel }
					</div>
					<div
						className='button__blue'
						onClick={ goToTemplateEditing }
					>
						{ dict.modals.checkTemplateAfterSimplification.button }
					</div>
				</section>
			</div>
		</div>
	);
};

export default ModalCheckTemplateAfterSimplification;